export default {
  title: {
    en: 'Shop the mothers day gift guide',
  },
  button: {
    en: 'Shop now',
  },
}
